import React, { useContext, useState, useEffect, useRef } from "react";
import Moment from "react-moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import AppContext from "../../Context/AppContext";
import { infoSource } from "../../util/util";
import "./RelacionAcreditados.css";

const RelacionAcreditados = React.forwardRef((props, ref) => {
  const { checkUserSession, changeLoading } = useContext(AppContext);

  const infoUs = checkUserSession();
  const [data, setData] = useState([]);
  const date = new Date();
  useEffect(() => {
    loadInfo();
  }, []);
  async function loadInfo() {
    changeLoading(true);
    const infoUs = checkUserSession();
    const listData = await infoSource.Reportes.RelacionAcreditados(infoUs);
    setData(listData);
    changeLoading(false);
  }

  function formatNumber(num) {
    const options2 = { style: "currency", currency: "USD" };
    const numberFormat2 = new Intl.NumberFormat("en-US", options2);
    return numberFormat2.format(num).replace("$", "");
  }
  function orderTable(prop) {
    setData(data);
    setData(
      data.sort((a, b) => (a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0))
    );
  }
  return (
    <section className="RelacionAcrteditados__Container" ref={ref}>
      <div className="RelacionAcrteditados__Titles">
        
        <h1>Relación de Acreditados</h1>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="btnNuevaGestion"
          table="tblRelacionAcreditados"
          filename={`Relacion de acreditados del gestor (${infoUs.CarGclave}) ${infoUs.GesRazonSocial}`}
          sheet="Acreditados"
          buttonText="Descargar como XLS"
        />
      </div>
      <table id="tblRelacionAcreditados">
        <thead>
          <tr className="RelacionAcreditadoHead">
            <th>gestor </th>
            <th>periodo </th>
            <th>Núm. Expdte. </th>
            <th>Nombre Acreditado </th>
            <th>nivel </th>
            <th>rfcac </th>
            <th>ProbRetirarse </th>
            <th>CapitalVdo </th>
            <th>InteresVdo </th>
            <th>Moratorios </th>
            <th>GastosCob </th>
            <th>SaldoDeudor </th>
            <th>totalven </th>
            <th>capxvencer </th>
            <th>intxvencer </th>
            <th>totxvenc </th>
            <th>adeudototal </th>
            <th>tquita </th>
            <th>conven </th>
            <th>FechInicioConven </th>
            <th>FechTerminoConven </th>
            <th>ImpteTotConven </th>
            <th>SaldoTotConven </th>
            <th>NumPagosPdtes </th>
            <th>VtoConvenMesActual</th>
            <th>VtoConvenMesSigte </th>
            <th>VtoNormalMesSigte </th>
            <th>reestruc </th>
            <th>demanda </th>
            <th>domicilioac </th>
            <th>coloniaac </th>
            <th>ciudadac </th>
            <th>municipioac </th>
            <th>estadoac </th>
            <th>paisac </th>
            <th>codposac </th>
            <th>telfam </th>
            <th>nombre del Aval </th>
            <th>rfcav </th>
            <th>domicilioav </th>
            <th>coloniaav </th>
            <th>ciudadav </th>
            <th>municipioav </th>
            <th>estadoav </th>
            <th>paisav </th>
            <th>codposav </th>
            <th>Telef.Aval </th>
            <th>DebeDesde </th>
            <th>upagomesanterior </th>
            <th>pago </th>
            <th>Otrotel1 </th>
            <th>AquienPertenece1 </th>
            <th>OtroTel2 </th>
            <th>Aquienpertenece2 </th>
            <th>Fecha Asig.Gestor </th>
            <th>email </th>
            <th>refebbva </th>
            <th>refebnmx </th>
            <th>NombreRef1 </th>
            <th>direccRef1 </th>
            <th>coloniaRef1 </th>
            <th>localiRef1 </th>
            <th>cpRef1 </th>
            <th>TelRef1 </th>
            <th>NombreRef2 </th>
            <th>direccRef2 </th>
            <th>coloniaRef2 </th>
            <th>localiRef2 </th>
            <th>cpRef2 </th>
            <th>TelRef2 </th>
            <th>ubicado </th>
            <th>CelularAcreditado </th>
            <th>atraso </th>
            <th>msinmov </th>
            <th>NombreTutor </th>
            <th>TelTutor </th>
            <th>CandidatoDVN </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => (
            <tr
              key={`RelacionAcreditadoRow${i}`}
              className="RelacionAcreditadoRow"
            >
              <td>{infoUs.CarGclave}</td>
              <td>
                {
                  <Moment
                    className="acreditadoUltimoPago"
                    locale="es"
                    format="DD/MMM/YYYY"
                    date={item.Periodo != null ? item.Periodo : ""}
                  />
                }
              </td>
              <td>{item.AcreditadoId}</td>
              <td>{item.Nombreac}</td>
              <td>{item.Nivel}</td>
              <td>{item.Rfcac}</td>
              <td>{item.ProbRetirarse}</td>
              <td>{item.CapitalVdo}</td>
              <td>{item.InteresVdo}</td>
              <td>{item.Moratorios}</td>
              <td>{item.GastosCob}</td>
              <td>{item.SaldoDeudor}</td>
              <td>{item.Totalven}</td>
              <td>{item.Capxvencer}</td>
              <td>{item.Intxvencer}</td>
              <td>{item.Totxvenc}</td>
              <td>{item.Adeudototal}</td>
              <td>{item.Tquita}</td>
              <td>{item.Conven}</td>
              <td>
                {" "}
                {
                  <Moment
                    className="acreditadoUltimoPago"
                    locale="es"
                    format="DD/MMM/YYYY"
                    date={item.FechInicioConven}
                  />
                }
              </td>
              <td>
                {" "}
                {
                  <Moment
                    className="acreditadoUltimoPago"
                    locale="es"
                    format="DD/MMM/YYYY"
                    date={item.FechTerminoConven}
                  />
                }
              </td>
              <td>{item.ImpteTotConven}</td>
              <td>{item.SaldoTotConven}</td>
              <td>{item.NumPagosPdtes}</td>
              <td>{item.VtoConvenMesActual}</td>
              <td>{item.VtoConvenMesSigte}</td>
              <td>{item.VtoNormalMesSigte}No existe</td>
              <td>{item.Reestruc == 1 ? "Si" : "No"}</td>
              <td>{item.Demanda == "S" ? "Si" : "No"}</td>
              <td>{item.Domicilioac}</td>
              <td>{item.Coloniaac}</td>
              <td>{item.Ciudadac}</td>
              <td>{item.Municipioac}</td>
              <td>{item.Estadoac}</td>
              <td>{item.Paisac}</td>
              <td>{item.Codposac}</td>
              <td>{item.Telfam}</td>
              <td>{item.Nombreav}</td>
              <td>{item.Rfcav}</td>
              <td>{item.Domicilioav}</td>
              <td>{item.Coloniaav}</td>
              <td>{item.Ciudadav}</td>
              <td>{item.Municipioav}</td>
              <td>{item.Estadoav}</td>
              <td>{item.Paisav}</td>
              <td>{item.Codposav}</td>
              <td>{item.Telav}</td>
              <td>
                {
                  <Moment
                    className="acreditadoUltimoPago"
                    locale="es"
                    format="DD/MMM/YYYY"
                    date={item.DebeDesde}
                  />
                }
              </td>
              <td>
                {
                  <Moment
                    className="acreditadoUltimoPago"
                    locale="es"
                    format="DD/MMM/YYYY"
                    date={item.Upagomesanterior}
                  />
                }
              </td>
              <td>{item.Pago}</td>
              <td>{item.Otrotel1}</td>
              <td>{item.AquienPertenece1}</td>
              <td>{item.OtroTel2}</td>
              <td>{item.Aquienpertenece2}</td>
              <td>{item.Fagesext}</td>
              <td>{item.Email}</td>
              <td>{item.Refebbva}</td>
              <td>{item.Refebnmx}</td>
              <td>{item.NombreRef1}</td>
              <td>{item.DireccRef1}</td>
              <td>{item.ColoniaRef1}</td>
              <td>{item.LocaliRef1}</td>
              <td>{item.CpRef1}</td>
              <td>{item.TelRef1}</td>
              <td>{item.NombreRef2}</td>
              <td>{item.DireccRef2}</td>
              <td>{item.ColoniaRef2}</td>
              <td>{item.LocaliRef2}</td>
              <td>{item.CpRef2}</td>
              <td>{item.TelRef2}</td>
              <td>{item.Ubicado}</td>
              <td>{item.CelularAcreditado}</td>
              <td>{item.Atraso}</td>
              <td>{item.Msinmov}</td>
              <td>{item.NombreTutor}</td>
              <td>{item.TelTutor}</td>
              <td>{item.CandidatoDvn}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
});
export default RelacionAcreditados;
